import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { MessageCircleIcon } from 'lucide-react';
import { CartDrawer } from './components/CartDrawer';
import { CartProvider } from './components/CartContext';
import { Nav } from './components/Nav';
import { Cursor } from './components/Cursor';
import { Footer } from './components/Footer';
import { IntroPreloader } from './components/IntroPreloader';
import { Home } from './pages/Home';
import { Envios } from './pages/Envios';
import { Faq } from './pages/Faq';
import { Privacidad } from './pages/Privacidad';
function ScrollToHash() {
  const {
    hash
  } = useLocation();
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (hash) {
      setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) {
          const nav = document.getElementById('nav');
          const offset = (nav?.offsetHeight ?? 0) + 24;
          window.scrollTo({
            top: (target as HTMLElement).offsetTop - offset,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function ScrollToTopOnLoad() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    const toTop = () => window.scrollTo(0, 0);
    toTop();
    requestAnimationFrame(toTop);
    const t1 = window.setTimeout(toTop, 60);
    const t2 = window.setTimeout(toTop, 250);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, []);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="suncq6knacg2">
      <CartProvider data-id="element-1" data-mp="su43rfcz2ye6">
        <ScrollToTopOnLoad data-id="element-2" data-mp="stkjhrzunxwz" />
        <ScrollToHash data-id="element-3" data-mp="ssssyvl40qdk" />
        <IntroPreloader data-id="element-4" data-mp="36hx792iaw2a" />
        <div className="w-full" data-id="element-5" data-mp="35oymvdpbcv8">
          <Cursor data-id="element-6" data-mp="34x31kk3tf4y" />
          <Nav data-id="element-7" data-mp="38kw6ilmzzj5" />
          <Routes data-id="element-8" data-mp="3uct25gan0gyw">
            <Route path="/" element={<Home data-id="element-10" data-mp="3ubzt28o7hfdl" />} data-id="element-9" data-mp="3udayecxauv6t" />
            <Route path="/pages/envios-devoluciones" element={<Envios data-id="element-12" data-mp="d57ep0qhqei0" />} data-id="element-11" data-mp="3ucjdbw1bwfus" />
            <Route path="/pages/preguntas-frecuentes" element={<Faq data-id="element-14" data-mp="85l30vqb96bb" />} data-id="element-13" data-mp="d3cuxpqygsfi" />
            <Route path="/pages/politica-de-privacidad" element={<Privacidad data-id="element-16" data-mp="3gleaym6kt9gr" />} data-id="element-15" data-mp="851n1kk80rzx" />
          </Routes>
          <Footer data-id="element-17" data-mp="3glwfs77b0w0a" />
          <CartDrawer data-id="element-18" data-mp="3gj1sm7wwox36" />
          <a href="https://wa.me/573213396782?text=Hola%20SAVIA%2C%20me%20interesa%20conocer%20m%C3%A1s%20sobre%20sus%20velas." className="wa-float" target="_blank" rel="noopener noreferrer" aria-label="Escríbenos por WhatsApp" data-id="element-19" data-mp="3bmjsjlcitmx6">
            <MessageCircleIcon size={18} strokeWidth={1.5} data-id="element-20" data-mp="2xun3xra29v5j" />
            <span className="wa-float__text" data-id="element-21" data-mp="2xt253pgprq1v">Escríbenos</span>
          </a>
        </div>
      </CartProvider>
    </BrowserRouter>;
}